import { put, select } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { RequestError } from "common/utilities/requestError";
import { initiateCreateModeFulfilled } from "domains/createMapDetail/actions";
import { activateModal } from "domains/modal/actions";
import type { InitTopicAction } from "domains/topicDetail/actionTypes";
import { handleCustomTopicUpdateFailureSaga } from "domains/topicDetail/sagas/handleCustomTopicUpdateFailureSaga";
import { setTransformationMapTopic } from "domains/transformationMap/actions";
import { getTmEditMode } from "domains/transformationMap/selectors";
import { fetchTopicFailure, fetchTopicSuccess } from "entities/topics/actions";
import type { Topic } from "entities/topics/types";
import { router } from "router/router";

export function* initTopicSaga({ meta }: InitTopicAction) {
  const { editMode, id, pathname } = meta;
  try {
    yield put(setTransformationMapTopic(meta));
    const topic: Topic = yield apiFetch(`map/${id}`);
    const isEditMode: ReturnType<typeof getTmEditMode> = yield select(getTmEditMode);
    yield put(fetchTopicSuccess({ topic }));
    if (isEditMode || editMode) {
      if (!topic.can_edit) yield router.navigate(`/topics/${topic.id}`, { replace: true });
      else yield put(initiateCreateModeFulfilled(topic));
    }
  } catch (error) {
    yield put(fetchTopicFailure(id, { logoutOnAuthError: true }));
    if (!(error instanceof RequestError)) return;
    if (error.status !== 401)
      yield put(activateModal({ id: "Error", params: { localisedMessageKey: "app.topic.unavailable.error_message" } }));
    yield handleCustomTopicUpdateFailureSaga({ errorStatus: error.status, pathname });
  }
}
